import React from 'react';

const DownloadSection = ({ paragraph, downloadButtonText, downloadLink }) => {
  if (!downloadButtonText || !downloadLink) {
    return null;
  }

  return (
    <div className="text-center mt-3 mb-5">
      {paragraph && <h5 className="text-muted">{paragraph}</h5>}
      <a href={downloadLink} download target="_blank" rel="noopener noreferrer" className="btn btn-primary">
        {downloadButtonText}
      </a>
    </div>
  );
};

export default DownloadSection;
